// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BotonCardComponent_container__x9WyZ {
  box-sizing: border-box;
  width: 100%;
  padding: 24px;
  border-radius: 20px;
  border: 1px solid rgba(226, 232, 240, 0.6);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.97), rgba(248, 250, 252, 0.9));
  box-shadow: 0 18px 36px -24px rgba(15, 23, 42, 0.5);
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 20px;
  cursor: pointer;
  text-align: left;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.BotonCardComponent_container__x9WyZ:hover {
  transform: translateY(-4px);
  border-color: rgba(148, 163, 184, 0.45);
  box-shadow: 0 28px 40px -22px rgba(15, 23, 42, 0.55);
}

.BotonCardComponent_container__x9WyZ:active {
  transform: translateY(-1px);
}

.BotonCardComponent_container__x9WyZ:focus-visible {
  outline: 2px solid rgba(37, 99, 235, 0.5);
  outline-offset: 3px;
}

.BotonCardComponent_iconWrapper__DUKjG {
  width: 60px;
  height: 60px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1f2937;
  transition: transform 0.2s ease;
}

.BotonCardComponent_container__x9WyZ:hover .BotonCardComponent_iconWrapper__DUKjG {
  transform: scale(1.07);
}

.BotonCardComponent_iconSvg__80myc {
  width: 30px;
  height: 30px;
  color: inherit;
}

.BotonCardComponent_content__MKy8r {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.BotonCardComponent_title__OebH2 {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.BotonCardComponent_description__zFm1v {
  font-size: 0.92rem;
  color: #64748b;
  margin: 0;
  line-height: 1.35;
}

.BotonCardComponent_chevron__Mzk8z {
  font-size: 1.55rem;
  color: #cbd5f5;
  transition: transform 0.2s ease, color 0.2s ease;
}

.BotonCardComponent_container__x9WyZ:hover .BotonCardComponent_chevron__Mzk8z {
  transform: translateX(6px);
  color: #93c5fd;
}

@media (max-width: 600px) {
  .BotonCardComponent_container__x9WyZ {
    padding: 20px;
    grid-template-columns: auto 1fr;
    gap: 16px;
  }

  .BotonCardComponent_chevron__Mzk8z {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/boton-card/BotonCardComponent.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,wFAAwF;EACxF,mDAAmD;EACnD,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,+BAA+B;IAC/B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 24px;\n  border-radius: 20px;\n  border: 1px solid rgba(226, 232, 240, 0.6);\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.97), rgba(248, 250, 252, 0.9));\n  box-shadow: 0 18px 36px -24px rgba(15, 23, 42, 0.5);\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 20px;\n  cursor: pointer;\n  text-align: left;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.container:hover {\n  transform: translateY(-4px);\n  border-color: rgba(148, 163, 184, 0.45);\n  box-shadow: 0 28px 40px -22px rgba(15, 23, 42, 0.55);\n}\n\n.container:active {\n  transform: translateY(-1px);\n}\n\n.container:focus-visible {\n  outline: 2px solid rgba(37, 99, 235, 0.5);\n  outline-offset: 3px;\n}\n\n.iconWrapper {\n  width: 60px;\n  height: 60px;\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #1f2937;\n  transition: transform 0.2s ease;\n}\n\n.container:hover .iconWrapper {\n  transform: scale(1.07);\n}\n\n.iconSvg {\n  width: 30px;\n  height: 30px;\n  color: inherit;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.description {\n  font-size: 0.92rem;\n  color: #64748b;\n  margin: 0;\n  line-height: 1.35;\n}\n\n.chevron {\n  font-size: 1.55rem;\n  color: #cbd5f5;\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.container:hover .chevron {\n  transform: translateX(6px);\n  color: #93c5fd;\n}\n\n@media (max-width: 600px) {\n  .container {\n    padding: 20px;\n    grid-template-columns: auto 1fr;\n    gap: 16px;\n  }\n\n  .chevron {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BotonCardComponent_container__x9WyZ`,
	"iconWrapper": `BotonCardComponent_iconWrapper__DUKjG`,
	"iconSvg": `BotonCardComponent_iconSvg__80myc`,
	"content": `BotonCardComponent_content__MKy8r`,
	"title": `BotonCardComponent_title__OebH2`,
	"description": `BotonCardComponent_description__zFm1v`,
	"chevron": `BotonCardComponent_chevron__Mzk8z`
};
export default ___CSS_LOADER_EXPORT___;
